import React from 'react'

import { MultipleAddressLine } from '@grandvision/forms'
import { useIntl } from '@grandvision/state'

export const Address = ({ required = true }) => {
  const { getLabel } = useIntl()

  return (
    <MultipleAddressLine
      label={getLabel('checkout.address.addressLine')}
      errorMessage={getLabel('checkout.address.addressLine.errorMessage')}
      addLineLabel={getLabel('checkout.address.addressLine.addAddressLine')}
      required={required}
      maxLength={50}
      initialLineAmount={2}
      lineTwoLabel={`${getLabel('checkout.address.addressLineTwo')}`}
    />
  )
}
